<template >
    <div class="page-header align-items-start min-vh-100 position-relative login-background">
        <span class="mask bg-gradient-light opacity-7"></span>
        <div class="container my-auto">
            <div class="row">
                <div class="col-lg-4 col-md-8 col-12 mx-auto">
                    <div class="card z-index-0 fadeIn3 fadeInBottom">                        
                        <div class="card-body">
                            <div class="text-center">
                                <img src="../../assets/img/Veeboek-logo.png" class="logo mb-2" alt="Vee Boek">
                            </div>

                            <div class="text-start mt-3">
                                <div class="text-center">
                                    <h3 class="text-green">{{ $t('resetpassword.Forgot_password') }}</h3>                                    
                                    <span class="text-sm text-muted">{{ $t('resetpassword.Reset_password_header') }}</span>                                    
                                </div>

                                <form @submit.prevent="resetPassword" id="resetPasswordForm">
                                    <div class="mb-3 mt-3">
                                        <label class="form-label">{{ $t('resetpassword.Email') }} *</label>
                                        <input type="text" class="input" v-model.trim="emailAddress">
                                        <span class="error-message text-danger" v-if="!emailAddress && attemptedResetPassword">{{ $t('resetpassword.Email_is_required') }}</span>
                                    </div>

                                    <div class="text-center">                                        
                                        <button type="submit" class="btn bg-gradient-success btn-md w-100 my-3">{{ $t('resetpassword.Reset_password') }}</button>
                                    </div>                                    
                                </form>
                                
                                <div class="text-center">
                                    <hr>
                                    <router-link to="/login" class="btn bg-gradient-light btn-md" style="display: inline-flex; align-items: center; justify-content: center;">
                                        <span class="material-symbols-outlined" style="font-size: 16px; margin-right: 2px;">arrow_circle_left</span> 
                                        {{ $t('resetpassword.Back_login_page') }}
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <auth-footer />
    </div>
</template>
  
<script>
import axios from 'axios'
import AuthFooter from './Footer.vue';
import { mapMutations } from "vuex";

export default {
    name: "Forgot_Password",
    components: {
        AuthFooter
    },
    data()
        {
            return {
                emailAddress:'',                
                attemptedResetPassword: false,                
                posts: []
            }
        },    
    mounted() {
        
    },    
    methods: {
        ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),                        
        async resetPassword() {    
                try {
                    this.attemptedResetPassword = true;
                    if (!this.emailAddress) {
                        return;
                    }

                    this.$store.commit('setShowLoading', true);   
                                   
                    const response = await axios.post("Auth/forgotpassword", { 
                        email: this.emailAddress
                    });
                        
                    this.posts = response.data;
                    
                    if(this.posts.success) {
                        this.$showSuccess('errors.Success_check_your_mailbox');
                        this.$router.push('/login');
                    } else{  
                        this.$showError('errors.Invalid_email');                        
                    }
                } catch (e) {      
                    const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                    this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);                    
                } finally {
                    this.$store.commit('setShowLoading', false); 
                }                
            }
    },
};
</script>
<style src="@/assets/css/auth.css"></style>
  